import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { normalizeUniformCase } from 'app/_utils/name-case';

/**
 * Rewrites single-case input (ALL CAPS or all lowercase) to title case once
 * the user leaves the field. Mixed-case input is never touched, so a
 * deliberate "McDonald" or "van der Berg" correction sticks.
 *
 * Usage: `appNameCase` on first/middle/last-name inputs,
 *        `appNameCase="address"` on street-address lines (keeps NW/PO/etc.).
 */
@Directive({
  selector: '[appNameCase]',
})
export class NameCaseDirective {
  @Input('appNameCase') mode: '' | 'address' = '';

  constructor(private readonly elRef: ElementRef<HTMLInputElement>) {}

  @HostListener('blur')
  onBlur(): void {
    const el = this.elRef.nativeElement;
    if (el.disabled || el.readOnly) return;

    const normalized = normalizeUniformCase(el.value || '', this.mode === 'address' ? 'address' : 'name');
    if (normalized !== el.value) {
      el.value = normalized;
      // Sync ngModel / reactive controls the same way TrimInputDirective does.
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
